import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cd9bc00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "module introduce" }
const _hoisted_2 = { class: "module-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-title" }, "核心能力介绍", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "module-subTitle" }, " 爱乐云专注于解决婚恋行业痛点，为您提供行业内最全面、最专业的系统化技术服务 ", -1))
const _hoisted_5 = {
  class: "introduce-operation",
  id: "operation"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "tab_title",
  style: {"margin-top":"60px"}
}, "精准获客", -1))
const _hoisted_7 = { class: "customer-services" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = {
  class: "introduce-customer",
  id: "customer"
}
const _hoisted_10 = { class: "tab_title" }
const _hoisted_11 = { class: "services" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "description" }
const _hoisted_14 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customersList, (customer, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "customer-card",
              key: index
            }, [
              _createElementVNode("h3", _hoisted_8, _toDisplayString(customer.title), 1),
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customer.points, (point, i) => {
                  return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(point), 1))
                }), 128))
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servicesList, (item, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            _createElementVNode("h2", _hoisted_10, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.serviceContent, (_item, _index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "service-card",
                  key: _index
                }, [
                  _createElementVNode("h3", _hoisted_12, _toDisplayString(_item.title), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_item.description), 1),
                  _createElementVNode("img", {
                    class: "service-icon",
                    src: require(`@/assets/images/service/${_item.icon}.png`)
                
                  }, null, 8, _hoisted_14)
                ]))
              }), 128))
            ])
          ], 64))
        }), 128))
      ])
    ])
  ]))
}